import React, { useState } from 'react';

/**
 * §3 — disclosed mid-spine fork affordance on a companion (peer) thread bubble.
 * A ⑂ toggle reveals two actions; re-roll deliberately stays OFF the bare hover row
 * (progressive disclosure). Both are callbacks so the bubble owns no fork logic
 * (New path = enter fork mode; Re-roll = the lens rerollPending handshake) — keeps
 * this component dependency-free + unit-testable.
 */
export function BubbleForkAffordance({
  onNewPath,
  onReroll,
  darkMode,
}: {
  onNewPath: () => void;
  onReroll: () => void;
  darkMode: boolean;
}) {
  const [open, setOpen] = useState(false);
  const item = `block w-full text-left px-3 py-1.5 ${darkMode ? 'hover:bg-teal-900/50' : 'hover:bg-teal-50'}`;
  return (
    <div className="relative" data-fork-affordance>
      <button
        type="button"
        data-fork-toggle
        aria-label="Fork from this message"
        title="Fork from here"
        onClick={(e) => { e.stopPropagation(); setOpen((o) => !o); }}
        className={`p-1 rounded text-xs leading-none ${
          darkMode ? 'bg-gray-700 text-gray-200 hover:bg-teal-800' : 'bg-gray-100 text-gray-700 hover:bg-teal-200'
        }`}
      >
        ⑂
      </button>
      {open && (
        <div
          className={`absolute right-0 top-full mt-1 z-20 rounded shadow-lg text-xs whitespace-nowrap ${
            darkMode ? 'bg-gray-800 text-gray-100 border border-gray-700' : 'bg-white text-gray-800 border border-gray-200'
          }`}
        >
          <button type="button" data-fork-new-path
            onClick={(e) => { e.stopPropagation(); setOpen(false); onNewPath(); }} className={item}>
            New path from here
          </button>
          <button type="button" data-fork-reroll
            onClick={(e) => { e.stopPropagation(); setOpen(false); onReroll(); }} className={item}>
            Re-roll
          </button>
        </div>
      )}
    </div>
  );
}
